import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { OnlySummaryLayout } from "../../../wm/components/transactions/dataentry/Layout";
import axios from "axios";
import { LoadPanel } from 'devextreme-react/load-panel';

function SummaryTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFieldSummaryTotals = {

        invoiceMTD: 0,
        invoiceYTD: 0,
        invoiceLTD: 0,
        invoicePriorY: 0,

        paymentMTD: 0,
        paymentYTD: 0,
        paymentLTD: 0,
        paymentPriorY: 0,

        discountMTD: 0,
        discountYTD: 0,
        discountLTD: 0,
        discountPriorY: 0,

        creditMTD: 0,
        creditYTD: 0,
        creditLTD: 0,
        creditPriorY: 0,

        paidMTD: 0,
        paidYTD: 0,
        paidLTD: 0,
        paidPriorY: 0,

        paidDueDateMTD: 0,
        paidDueDateYTD: 0,
        paidDueDateLTD: 0,
        paidDueDatePrior: 0,

        postedMTD: 0,
        postedYTD: 0,
        postedLTD: 0,
        postedPriorY: 0,

        paidLateMTD: 0,
        paidLateYTD: 0,
        paidLateLTD: 0,
        paidLatePriorY: 0,

        avgDaysPayMTD: 0,
        avgDaysPayYTD: 0,
        avgDaysPayLTD: 0,
        avgDaysPayPriorY: 0,

        CurrentBalance: 0,
        LastStmBalance: 0,
        LastStmDate: 0,
    };
    const [formFieldSummaryTotals, setformFieldSummaryTotals] = useState(initialFormFieldSummaryTotals);
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const onFormLoad = useCallback(() => {
        summaryFormLoaded(formRefs);
    });
    const handleFieldChange = useCallback((name, value) => {
    });
    const handleSelectionChange = useCallback((name, e) => {
    }, []);
    const summaryFormLoaded = async (formRefs) => {
        if (props.customerId) {
            const totals = await fetchSummaryTotalsData(props.customerId);
            mapSummaryTotals(formRefs, totals);
        }
        else {
            mapSummaryTotals(formRefs, initialFormFieldSummaryTotals);
        }

    }
    const mapSummaryTotals = (formRefs, formFieldSummaryTotals) => {
        const fields = {
            InvoiceMTD: formFieldSummaryTotals.invoiceMTD,
            InvoiceYTD: formFieldSummaryTotals.invoiceYTD,
            InvoiceLTD: formFieldSummaryTotals.invoiceLTD,
            InvoicePriorY: formFieldSummaryTotals.invoicePriorY,
            PaymentMTD: formFieldSummaryTotals.paymentMTD,
            PaymentYTD: formFieldSummaryTotals.paymentYTD,
            PaymentLTD: formFieldSummaryTotals.paymentLTD,
            PaymentPriorY: formFieldSummaryTotals.paymentPriorY,
            DiscountMTD: formFieldSummaryTotals.discountMTD,
            DiscountYTD: formFieldSummaryTotals.discountYTD,
            DiscountLTD: formFieldSummaryTotals.discountLTD,
            DiscountPriorY: formFieldSummaryTotals.discountPriorY,
            CreditMTD: formFieldSummaryTotals.creditMTD,
            CreditYTD: formFieldSummaryTotals.creditYTD,
            CreditLTD: formFieldSummaryTotals.creditLTD,
            CreditPriorY: formFieldSummaryTotals.creditPriorY,
            PaidMTD: formFieldSummaryTotals.paidMTD,
            PaidYTD: formFieldSummaryTotals.paidYTD,
            PaidLTD: formFieldSummaryTotals.paidLTD,
            PaidPriorY: formFieldSummaryTotals.paidPriorY,
            PaidDueDateMTD: formFieldSummaryTotals.paidDueDateMTD,
            PaidDueDateYTD: formFieldSummaryTotals.paidDueDateYTD,
            PaidDueDateLTD: formFieldSummaryTotals.paidDueDateLTD,
            PaidDueDatePriorY: formFieldSummaryTotals.paidDueDatePriorY,
            PostedMTD: formFieldSummaryTotals.postedMTD,
            PostedYTD: formFieldSummaryTotals.postedYTD,
            PostedLTD: formFieldSummaryTotals.postedLTD,
            PostedPriorY: formFieldSummaryTotals.postedPriorY,
            PaidLateMTD: formFieldSummaryTotals.paidLateMTD,
            PaidLateYTD: formFieldSummaryTotals.paidLateYTD,
            PaidLateLTD: formFieldSummaryTotals.paidLateLTD,
            PaidLatePriorY: formFieldSummaryTotals.paidLatePriorY,
            AvgDaysPayMTD: formFieldSummaryTotals.avgDaysPayMTD,
            AvgDaysPayYTD: formFieldSummaryTotals.avgDaysPayYTD,
            AvgDaysPayLTD: formFieldSummaryTotals.avgDaysPayLTD,
            AvgDaysPayPriorY: formFieldSummaryTotals.avgDaysPayPriorY,
            CurrentBalance: formFieldSummaryTotals.currentBalance,
            CustomerLASTSTATEMENTDATE: formFieldSummaryTotals.lastStmDate,
            CustomerLASTSTATEMENTBALANCE: formFieldSummaryTotals.lastStmBalance,
        };

        Object.entries(fields).forEach(([key, value]) => {
            if (formRefs.current[key]) {
                formRefs.current[key].instance().option('value', value);
                formRefs.current[key].instance().option('disabled', true);
            }
        });
    }
    const fetchSummaryTotalsData = async (id) => {
        try {
            setLoadPanelVisible(true);
            const res = await axios.get(
                `${window._env_.REACT_APP_APIS}/id/Customer/GetSummaryTotals?customerId=${id}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            if (res.data) {
                return res.data;

            } else {
                console.warn("No companies data available.");
            }
        } catch (err) {
            console.log(err, "Error while getting databases");
        }
        finally {
            setLoadPanelVisible(false);
        }
    };

    return (
        <div className="FormMt">
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <FormField
                currrentUser={currentUser}
                layoutId='54D91028-8B69-43E1-9370-3A68A9153AD5'
                layoutName='SummaryForm'
                defaultFormSchema={OnlySummaryLayout}
                formFields={formFieldSummaryTotals}
                setformFields={setformFieldSummaryTotals}
                onFormLoad={onFormLoad}
                handleFieldValueChange={handleFieldChange}
                handleSelectedItemChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
            />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(SummaryTab);